/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState} from "react";
import PropTypes from "prop-types";

import BrokeragePricing from "./BrokeragePricing";

const propTypes = {
  partnerData: PropTypes.object,
  rCode: PropTypes.string
};

const BrokeragePricingContainer = ({
  rCode,
  partnerData
}) => {
  const [toggleModal, setToggleModal] = useState(false);

  const brokerageList = [
    {
      price: "0",
      title: "Account Opening Charges"
    },
    {
      price: "15",
      title: "Equity Delivery and Intraday Charges",
      context: "Or 0.1% per order whichever is lower"
    },
    {
      price: "15",
      title: "per order for Options"
    },
    {
      price: "15",
      title: "per order for Futures"
    }
  ];

  return (
    <BrokeragePricing
      brokerageList={brokerageList}
      partnerData={partnerData}
      rCode={rCode}
      setToggleModal={setToggleModal}
      toggleModal={toggleModal}
    />
  );
};

BrokeragePricingContainer.propTypes = propTypes;

export default BrokeragePricingContainer;
